(() => {
  // SOLO dentro de Product information (PDP)
  const ROOT = '.product-information';
  const SELECTOR = `${ROOT} .text-block[data-readmore="true"][data-readmore-scope="pdp"]`;

  function getLabels(block) {
    return {
      more: block.dataset.readmoreMore || 'Ver más',
      less: block.dataset.readmoreLess || 'Ver menos',
    };
  }

  function syncButtonLabel(block) {
    const btn = block.querySelector(':scope > .readmore-btn');
    if (!btn) return;

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const { more, less } = getLabels(block);
    btn.textContent = expanded ? less : more;
  }

  function ensureWrapper(block) {
    let wrapper = block.querySelector(':scope > .readmore-content');
    if (wrapper) return wrapper;

    // Si hay un único contenedor directo, lo reutilizamos
    const direct = block.querySelector(':scope > rte-formatter, :scope > div');
    if (direct && !direct.classList.contains('readmore-btn')) {
      direct.classList.add('readmore-content');
      return direct;
    }

    // Caso como el tuyo: h1/p directos => creamos wrapper y movemos TODO dentro
    wrapper = document.createElement('div');
    wrapper.className = 'readmore-content';

    const toMove = [];
    block.childNodes.forEach((n) => {
      if (n.nodeType === 1 && n.classList?.contains('readmore-btn')) return;
      toMove.push(n);
    });
    toMove.forEach((n) => wrapper.appendChild(n));

    block.insertBefore(wrapper, block.firstChild);
    return wrapper;
  }

  function setup(block) {
    if (!block) return;

    // Guard extra por si acaso
    if (!block.closest(ROOT)) return;

    if (block.dataset.readmoreInit === '1') {
      syncButtonLabel(block);
      return;
    }

    const maxh = parseInt(block.dataset.readmoreMaxh || '180', 10);
    const fade = parseInt(block.dataset.readmoreFade || '48', 10);

    block.style.setProperty('--readmore-maxh', `${maxh}px`);
    block.style.setProperty('--readmore-fade', `${fade}px`);

    const wrapper = ensureWrapper(block);
    if (!wrapper) return;

    // Colapsa para medir
    block.classList.add('is-collapsed');

    const hasOverflow = wrapper.scrollHeight > maxh + 1;
    if (!hasOverflow) {
      block.classList.remove('is-collapsed');
      block.dataset.readmoreInit = '1';
      return;
    }

    if (!block.querySelector(':scope > .readmore-btn')) {
      const { more } = getLabels(block);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'readmore-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = more;

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const { more, less } = getLabels(block);
        btn.setAttribute('aria-expanded', String(!expanded));
        block.classList.toggle('is-collapsed', expanded);
        btn.textContent = expanded ? more : less;
      });

      block.appendChild(btn);
    }

    syncButtonLabel(block);

    block.dataset.readmoreInit = '1';
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
  idle(init);

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener?.('pageswap', init);
})();
